import React, { Component } from "react";

import Section from "../components/Section";

class BackgroundSection extends Component {
  render() {
    return (
      <Section id="background" className="background-section">
        <div>Background Section</div>
      </Section>
    );
  }
}

export default BackgroundSection;
